import { useMutation, useQueryClient } from 'react-query';
import { successToast } from 'lib/components/toasts/success';
import { errorToast } from 'lib/components/toasts/error';
import { EXPRESS_API } from 'configs/api/expressApi';

export interface IDeleteTemplateRequestValues {
  templateId: number;
  replacementLandingPageDesignId?: number | string;
}

export const deleteLandingPageDesign = async ({
  templateId,
  replacementLandingPageDesignId,
}: IDeleteTemplateRequestValues) => {
  const params = {
    replacementLandingPageDesignId,
  };
  const response = await EXPRESS_API.delete(
    `/superadmin/landing-page-designs/${templateId}`,
    { params }
  );
  return response.data;
};

interface ILandingPageDesignDeleteMutationParams {
  showToastNotifications?: boolean;
  closeModalHandler?: () => void;
}

export const useDeleteLandingPageDesignMutation = ({
  showToastNotifications = true,
  closeModalHandler,
}: ILandingPageDesignDeleteMutationParams) => {
  const queryClient = useQueryClient();
  return useMutation(deleteLandingPageDesign, {
    onSuccess: () => {
      if (showToastNotifications) {
        successToast({
          title: 'Template has been successfully deleted!',
        });
      }
      if (closeModalHandler) {
        closeModalHandler();
      }
      queryClient.refetchQueries({
        queryKey: 'LANDING_PAGE_DESIGNS',
        exact: false,
      });

      queryClient.refetchQueries({
        queryKey: 'LANDING_PAGE_DESIGN_GROUPS',
        exact: false,
      });
    },
    onError: () => {
      if (showToastNotifications) {
        errorToast({
          title:
            'An error occurred when attempting to delete the template. Please try again later.',
        });
      }
    },
  });
};
